export const breakpoints = {
  largeDeviceMinWidth: 1201,
  mediumDeviceMaxWidth: 1200,
  mediumDeviceMinWidth: 721,
  smallDeviceMaxWidth: 720,
};
